import React from 'react';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from '../button';

import type { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

import './style.scss';

export type Props = {
  bodyText?: string,
  bordered?: boolean,
  buttonIcon?: IconProp,
  buttonText?: string,
  buttonType?: string,
  children?: React.ReactNode,
  className?: string,
  header?: string,
  icon?: IconProp,
  iconSize?: SizeProp,
  plainButton?: boolean,
  style?: React.CSSProperties,
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void,
}

export default function EmptyState({
  bodyText,
  bordered = true,
  buttonIcon,
  buttonText,
  children,
  className,
  header,
  icon,
  iconSize = '4x',
  plainButton = true,
  style,
  onClick
}: Props) {
  const buttonProps = {
    icon: buttonIcon,
    label: buttonText,
    plain: false,
    onClick,
  };

  if (plainButton) {
    buttonProps.plain = true;
  }

  const blockName = 'ds-empty-state';
  return (
    <div
      className={
        classNames(
          blockName,
          className,
          'gap-4 d-flex flex-column align-items-center justify-content-center w-100 p-4',
          {
            [`${blockName}--bordered`]: bordered,
            'h-100': !style?.height
          },
        )
      }
      style={style || {}}
    >
      {icon ? (
        <FontAwesomeIcon className="icon-gradient" icon={icon} size={iconSize}/>
      ) : null}
      {header ? (<h3 className="m-0 text-center"><strong>{header}</strong></h3>) : null}
      {bodyText ? (<div className="ds-text-muted">{bodyText}</div>) : null}
      {buttonText && onClick ? <Button.Secondary {...buttonProps} /> : null}
      {children}
    </div>
  );
}
